export enum ClockOutValueType {
  Unit = 1,
  Money = 2,
}
